// 仪表板模块多语言配置
export const dashboard = {
  'zh-CN': {
    myStatistics: '我的统计',
    enterpriseStatistics: '企业统计',
    totalCustomers: '总客户数',
    newCustomers: '新增客户',
    totalOrders: '总订单数',
    totalRevenue: '总收入',
    customerGrowth: '客户增长',
    orderGrowth: '订单增长',
    revenueGrowth: '收入增长',
    loginTime: '登录时间',
    manageAccount: '管理账户',
    openedCards: '已开通名片(人)',
    remainingCards: '剩余名片人数',
    authorizationInfo: '授权信息',
    authorizationStartTime: '这是您的授权开始时间',
    // 数据概览
    dataOverview: '数据概览',
    totalCustomer: '总客户',
    todayEntry: '今日录入',
    dealCustomer: '成交客户',
    exclusiveCustomer: '独占客户',
    dealRate: '成交率',
    todayNew: '今日新增',
    todayEntryList: '今日录入',
    // 时间选择
    cumulative: '累计',
    today: '今日',
    last7Days: '近7天',
    selectDate: '选择日期',
    yesterday: '昨天',
    weekAgo: '一周前',
    // 订单统计
    conversionFunnel: '转化率漏斗',
    orderAmount: '商城订单总额',
    orderCount: '商城订单数量',
    performanceTarget: '业绩目标',
    performanceGap: '业绩差额',
    dealAmount: '已成交',
    monthlyTarget: '月目标',
    remainingAmount: '还差',
    monthlyDealCount: '本月已成交',
    browse: '浏览',
    placeOrder: '下单',
    payment: '付款',
    orderConversionRate: '下单转化率',
    paymentConversionRate: '付款转化率',
    dealConversionRate: '成交转化率',
    last30Days: '近30天',
    last7Days: '近7天',
    pleaseSelect: '请选择',
    // 待办事项
    todoItems: '待办事项',
    todayNeedFollow: '今日需跟进',
    people: '人',
    notFollowed7Days: '已经7天未跟进客户了哦',
    goFollow: '去跟进',
    todayFollowed: '今日已跟进',
    customer: '客户',
    todayNotFollowed: '今日未跟进',
    customerInterest: '客户兴趣',
    // 客户兴趣类型
    interestedInMe: '对我感兴趣',
    likeProduct: '喜欢产品',
    valueCompany: '看重公司',
    followUpdates: '关注动态',
    appointment: '预约',
    media: '媒体',
    // 订单类型
    mallOrder: '商城订单',
    personalOrder: '个人线下订单',
    // 兴趣相关
    interest: '兴趣',
    // 图表相关
    completed: '已完成',
    incomplete: '未完成',
    exceeded: '已超额',
    performanceGap: '业绩差额',
    completionRate: '完成度',
    // 账号管理
    accountManagement: '账号管理',
    createTime: '创建时间',
    loginAccount: '登录账号',
    setPassword: '设置密码',
    changePassword: '修改密码',
    forgotPassword: '忘记密码',
    securityVerification: '安全验证',
    setNewPassword: '设置新密码',
    setSuccess: '设置成功',
    phoneRetrieval: '手机号找回',
    emailRetrieval: '邮箱找回',
    enterEmailAddress: '请输入邮箱地址',
    enterSmsCode: '请输入短信验证码',
    enterEmailCode: '请输入邮箱验证码',
    getVerificationCode: '获取验证码',
    resend: '重新发送',
    nextStep: '下一步',
    previousStep: '上一步',
    confirm: '确认',
    cancel: '取消',
    password: '密码',
    confirmPassword: '确认密码',
    enterPassword: '请输入密码',
    enterConfirmPassword: '请再次输入密码',
    passwordNotMatch: '两次输入的密码不一致',
    passwordLength: '密码长度不能少于6位',
    passwordSuccess: '密码设置成功',
    unit: '单',
    remainingDays: '剩余天数',
    expired: '已过期',
    usedDays: '使用天数',
    // 错误消息
    pleaseEnterVerificationCode: '请输入验证码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseRepeatNewPassword: '请重复输入新密码',
    passwordsDoNotMatch: '两次输入内容不一样，请重新输入',
    smsCodeError: '短信验证码错误，请重新输入',
    emailCodeError: '邮箱验证码错误，请重新输入',
    modifySuccess: '修改成功',
    pleaseEnterOldPassword: '请输入旧密码',
    getCompanyInfoError: '获取企业信息异常',
    // 密码管理相关
    enterPassword: '请输入密码',
    enterConfirmPassword: '请再次输入密码',
    enterSmsCode: '请输入短信验证码',
    enterEmailCode: '请输入邮箱验证码',
    enterEmailAddress: '请输入邮箱地址',
    phoneRetrieval: '手机号找回',
    emailRetrieval: '邮箱找回',
    securityVerification: '安全验证',
    setNewPassword: '设置新密码',
    setSuccess: '设置成功',
    getVerificationCode: '获取验证码',
    resend: '重新发送',
    nextStep: '下一步',
    previousStep: '上一步',
    confirm: '确认',
    cancel: '取消',
    password: '密码',
    confirmPassword: '确认密码',
    passwordNotMatch: '两次输入的密码不一致',
    passwordLength: '密码长度不能少于6位',
    passwordSuccess: '密码设置成功',
    // 错误消息
    pleaseEnterVerificationCode: '请输入验证码',
    pleaseEnterNewPassword: '请输入新密码',
    pleaseRepeatNewPassword: '请重复输入新密码',
    passwordsDoNotMatch: '两次输入内容不一样，请重新输入',
    smsCodeError: '短信验证码错误，请重新输入',
    emailCodeError: '邮箱验证码错误，请重新输入',
    modifySuccess: '修改成功',
    // 警告消息
    warning: '警告',
    pleaseEnterCorrectEmail: '请输入正确的邮箱地址'
  },
  'zh-TW': {
    myStatistics: '我的統計',
      enterpriseStatistics: '企業統計',
      totalCustomers: '總客戶數',
      newCustomers: '新增客戶',
      totalOrders: '總訂單數',
      totalRevenue: '總收入',
      customerGrowth: '客戶增長',
      orderGrowth: '訂單增長',
      revenueGrowth: '收入增長',
      loginTime: '登錄時間',
      manageAccount: '管理賬戶',
      openedCards: '已開通名片(人)',
      remainingCards: '剩餘名片人數',
      authorizationInfo: '授權信息',
      authorizationStartTime: '這是您的授權開始時間',
      // 數據概覽
      dataOverview: '數據概覽',
      totalCustomer: '總客戶',
      todayEntry: '今日錄入',
      dealCustomer: '成交客戶',
      exclusiveCustomer: '獨占客戶',
      dealRate: '成交率',
      todayNew: '今日新增',
      todayEntryList: '今日錄入',
      // 時間選擇
      cumulative: '累計',
      today: '今日',
      last7Days: '近7天',
      selectDate: '選擇日期',
      yesterday: '昨天',
      weekAgo: '一週前',
      // 訂單統計
      conversionFunnel: '轉化率漏斗',
      orderAmount: '商城訂單總額',
      orderCount: '商城訂單數量',
      performanceTarget: '業績目標',
      performanceGap: '業績差額',
      dealAmount: '已成交',
      monthlyTarget: '月目標',
      remainingAmount: '還差',
      monthlyDealCount: '本月已成交',
      browse: '瀏覽',
      placeOrder: '下單',
      payment: '付款',
      orderConversionRate: '下單轉化率',
      paymentConversionRate: '付款轉化率',
      dealConversionRate: '成交轉化率',
      last30Days: '近30天',
      last7Days: '近7天',
      pleaseSelect: '請選擇',
      // 待辦事項
      todoItems: '待辦事項',
      todayNeedFollow: '今日需跟進',
      people: '人',
      notFollowed7Days: '已經7天未跟進客戶了哦',
      goFollow: '去跟進',
      todayFollowed: '今日已跟進',
      customer: '客戶',
      todayNotFollowed: '今日未跟進',
      customerInterest: '客戶興趣',
      // 客戶興趣類型
      interestedInMe: '對我感興趣',
      likeProduct: '喜歡產品',
      valueCompany: '看重公司',
      followUpdates: '關注動態',
      appointment: '預約',
      media: '媒體',
          // 訂單類型
    mallOrder: '商城訂單',
    personalOrder: '個人線下訂單',
    // 興趣相關
    interest: '興趣',
    // 圖表相關
    completed: '已完成',
    incomplete: '未完成',
    exceeded: '已超額',
    performanceGap: '業績差額',
    completionRate: '完成度',
    // 賬號管理相關
    accountManagement: '賬號管理',
    createTime: '創建時間',
    loginAccount: '登錄賬號',
    setPassword: '設置密碼',
    changePassword: '修改密碼',
    forgotPassword: '忘記密碼',
    securityVerification: '安全驗證',
    setNewPassword: '設置新密碼',
    setSuccess: '設置成功',
    phoneRetrieval: '手機號找回',
    emailRetrieval: '郵箱找回',
    enterEmailAddress: '請輸入郵箱地址',
    enterSmsCode: '請輸入短信驗證碼',
    enterEmailCode: '請輸入郵箱驗證碼',
    getVerificationCode: '獲取驗證碼',
    resend: '重新發送',
    nextStep: '下一步',
    previousStep: '上一步',
    confirm: '確認',
    cancel: '取消',
    password: '密碼',
    confirmPassword: '確認密碼',
    enterPassword: '請輸入密碼',
    enterConfirmPassword: '請再次輸入密碼',
    passwordNotMatch: '兩次輸入的密碼不一致',
    passwordLength: '密碼長度不能少於6位',
    passwordSuccess: '密碼設置成功',
    // 錯誤消息
    pleaseEnterVerificationCode: '請輸入驗證碼',
    pleaseEnterNewPassword: '請輸入新密碼',
    pleaseRepeatNewPassword: '請重複輸入新密碼',
    passwordsDoNotMatch: '兩次輸入內容不一樣，請重新輸入',
    smsCodeError: '短信驗證碼錯誤，請重新輸入',
    emailCodeError: '郵箱驗證碼錯誤，請重新輸入',
    modifySuccess: '修改成功',
    pleaseEnterOldPassword: '請輸入舊密碼',
    getCompanyInfoError: '獲取企業信息異常',
    // 警告消息
    warning: '警告',
    pleaseEnterCorrectEmail: '請輸入正確的郵箱地址'
  },
  'en': {
    myStatistics: 'My Statistics',
    enterpriseStatistics: 'Enterprise Statistics',
    totalCustomers: 'Total Customers',
    newCustomers: 'New Customers',
    totalOrders: 'Total Orders',
    totalRevenue: 'Total Revenue',
    customerGrowth: 'Customer Growth',
    orderGrowth: 'Order Growth',
    revenueGrowth: 'Revenue Growth',
    loginTime: 'Login Time',
    manageAccount: 'Manage Account',
    openedCards: 'Opened Cards (People)',
    remainingCards: 'Remaining Cards',
    authorizationInfo: 'Authorization Info',
    authorizationStartTime: 'This is your authorization start time',
    // Data Overview
    dataOverview: 'Data Overview',
    totalCustomer: 'Total Customer',
    todayEntry: 'Today Entry',
    dealCustomer: 'Deal Customer',
    exclusiveCustomer: 'Exclusive Customer',
    dealRate: 'Deal Rate',
    todayNew: 'Today New',
    todayEntryList: 'Today Entry',
    // Time Selection
    cumulative: 'Cumulative',
    today: 'Today',
    last7Days: 'Last 7 Days',
    selectDate: 'Select Date',
    yesterday: 'Yesterday',
    weekAgo: 'Week Ago',
    // Order Statistics
    conversionFunnel: 'Conversion Funnel',
    orderAmount: 'Mall Order Amount',
    orderCount: 'Mall Order Count',
    performanceTarget: 'Performance Target',
    performanceGap: 'Performance Gap',
    dealAmount: 'Deal Amount',
    monthlyTarget: 'Monthly Target',
    remainingAmount: 'Remaining Amount',
    monthlyDealCount: 'Monthly Deal Count',
    browse: 'Browse',
    placeOrder: 'Place Order',
    payment: 'Payment',
    orderConversionRate: 'Order Conversion Rate',
    paymentConversionRate: 'Payment Conversion Rate',
    dealConversionRate: 'Deal Conversion Rate',
    last30Days: 'Last 30 Days',
    last7Days: 'Last 7 Days',
    pleaseSelect: 'Please Select',
    // Todo Items
    todoItems: 'Todo Items',
    todayNeedFollow: 'Today Need Follow',
    people: 'People',
    notFollowed7Days: 'Not followed for 7 days',
    goFollow: 'Go Follow',
    todayFollowed: 'Today Followed',
    customer: 'Customer',
    todayNotFollowed: 'Today Not Followed',
    customerInterest: 'Customer Interest',
    // Customer Interest Types
    interestedInMe: 'Interested in Me',
    likeProduct: 'Like Product',
    valueCompany: 'Value Company',
    followUpdates: 'Follow Updates',
    appointment: 'Appointment',
    media: 'Media',
    // Order Types
    mallOrder: 'Mall Order',
    personalOrder: 'Personal Offline Order',
    // Interest Related
    interest: 'Interest',
    // Chart Related
    completed: 'Completed',
    incomplete: 'Incomplete',
    exceeded: 'Exceeded',
    performanceGap: 'Performance Gap',
    completionRate: 'Completion Rate',
    // Account Management
    accountManagement: 'Account Management',
    createTime: 'Create Time',
    loginAccount: 'Login Account',
    setPassword: 'Set Password',
    changePassword: 'Change Password',
    forgotPassword: 'Forgot Password',
    securityVerification: 'Verification',
    setNewPassword: 'Set New Password',
    setSuccess: 'Set Success',
    phoneRetrieval: 'Phone Retrieval',
    emailRetrieval: 'Email Retrieval',
    enterEmailAddress: 'Enter Email Address',
    enterSmsCode: 'Enter SMS Code',
    enterEmailCode: 'Enter Email Code',
    getVerificationCode: 'Get Code',
    resend: 'Resend',
    nextStep: 'Next Step',
    previousStep: 'Previous Step',
    confirm: 'Confirm',
    cancel: 'Cancel',
    password: 'Password',
    confirmPassword: 'Confirm Password',
    enterPassword: 'Enter Password',
    enterConfirmPassword: 'Enter Confirm Password',
    passwordNotMatch: 'Passwords do not match',
    passwordLength: 'Password length must be at least 6 characters',
    passwordSuccess: 'Password set successfully',
    // Error Messages
    pleaseEnterVerificationCode: 'Please enter verification code',
    pleaseEnterNewPassword: 'Please enter new password',
    pleaseRepeatNewPassword: 'Please repeat new password',
    passwordsDoNotMatch: 'Passwords do not match, please re-enter',
    smsCodeError: 'SMS verification code error, please re-enter',
    emailCodeError: 'Email verification code error, please re-enter',
    modifySuccess: 'Modified successfully',
    pleaseEnterOldPassword: 'Please enter old password',
    getCompanyInfoError: 'Failed to get company information',
    // Warning Messages
    warning: 'Warning',
    pleaseEnterCorrectEmail: 'Please enter correct email address'
  }
}; 